<template lang="pug">
v-card.px-1.main-container.elevation-0
  v-container(fluid).ma-0.my-1.pa-0.header-container
    v-tooltip(
      bottom
      max-width="200"
      :disabled="isCurrentContactOwnedByCurrentUser")
      span Only the owner of this contact can add relationships
      v-layout(align-center slot="activator")
        v-layout(align-center)
          span.card-title Contact Relationships ({{ relationshipsCount }})
        v-layout(align-center, justify-end)
          v-btn(
            v-if="isCurrentContactOwnedByCurrentUser"
            @click='onOpenModal'
            ).card-action + Add
          v-icon(color='#F7883E', @click='changeDescriptionView').clickable {{ expandDescription ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
  contact-relationships-view(
    id="contact-relationships"
    v-if="relationshipsCount > 0"
    :expandDescription='expandDescription'
    @refresh-relationships="$emit('refresh-relationships')"
    @showChatDrawer="$emit('showChatDrawer', $event)"
    @openEmailDrawer="$emit('openEmailDrawer')"
    :viewAll="viewAll"
    :is-main-contact-owned="isCurrentContactOwnedByCurrentUser"
  )
  v-layout(v-if="relationshipsCount > 0 && expandDescription" align-center justify-center row wrap grey lighten-3)
    v-flex(v-if="relationshipsCount > 5" xs12 align-self-center)
      v-layout(align-center justify-center row wrap).viewAllAction
        a(@click="toggleViewAll") {{ viewAll ? "View less" : "View all" }}
    v-flex(xs6 align-self-center)
      v-layout(align-center justify-center row wrap)
        v-btn(flat color="primary" @click="showDrawerEmail").panelName
          v-icon(size="20").pr-1 email
          span Email All
    v-flex(xs6 align-self-center)
      v-layout(align-center justify-center row wrap)
        v-btn(flat color="primary" @click="goToBulkTextView").panelName
          v-icon(size="20").pr-1 smartphone
          span Text All
  add-contact-relationships(v-else :expandDescription='expandDescription' :disableButton="!isCurrentContactOwnedByCurrentUser")
  contact-relationship-modal(:contactId="contactId" @saveSnackbar="saveSnackbar")
  v-snackbar(v-model="getRelationshipResponse" color="success")
    div One or more contacts were related successfully.

</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import AddContactRelationships from '@/Contacts/components/profile-v2/ContactRelationships/AddContactRelationships';
import ContactRelationshipsView from '@/Contacts/components/profile-v2/ContactRelationships/ContactRelationshipsView';
import ContactRelationshipModal from '@/Contacts/components/profile-v2/ContactRelationships/ContactRelationshipModal';

export default {
  name: 'ContactRelationships',
  components: {
    AddContactRelationships,
    ContactRelationshipsView,
    ContactRelationshipModal,
  },
  props: {
    contactId: {
      type: Number,
      default: 0,
    }
  },

  data() {
    return {
      viewAll: false,
      expandDescription: true,
      saveRelationship: false,
    };
  },

  async created() {
    await this.fetchRelationshipTypes();
  },

  computed: {
    ...mapState('contactRelationships', ['allRelsSuccessful', 'relatedContacts']),
    ...mapState({
      currentUser: state => state.userInformation.user,
    }),
    ...mapState('contact', ['contact']),
    ...mapGetters('contactRelationships',['relationshipsCount']),
    ...mapGetters('contact', ['currentContact']),
    getRelationshipResponse: {
      get() {
        return this.allRelsSuccessful;
      },
      set(value) {
        this.setAllRelsSuccessful(value);
      },
    },
    isCurrentContactOwnedByCurrentUser() {
      const { contactOwner } = this.currentContact;
      if (!this.currentUser) return false
      return this.currentUser.id === contactOwner.id;
    },
    contactsRelated() {
      return this.relatedContacts.map(rel => {
        return rel.main_contact.id != this.contactId ? rel.main_contact : rel.related_contact;
      });
    },
  },

  watch: {
    contactId: {
      handler(newValue) {
        this.fetchContactRelationships(newValue);
      },
    },
  },

  methods: {
    ...mapActions('contactRelationships', [
      'fetchRelationshipTypes',
      'fetchContactRelationships',
      'setShowModal',
      'resetResponseSaveRelationship',
      'setAllRelsSuccessful'
    ]),
    ...mapActions('recipients', ['setToSelected']),
    async toggleViewAll() {
      this.viewAll = !this.viewAll;
      //nextTick() used to wait the DOM to render before scrolling to lastElementChild
      await this.$nextTick()
      const lastPanel = document.body.querySelector('#contact-relationships').lastElementChild.lastElementChild;
      if (lastPanel) {
        lastPanel.scrollIntoView({behavior: 'smooth'});
      }
    },
    changeDescriptionView() {
      this.expandDescription = !this.expandDescription;
    },
    onOpenModal() {
      this.setShowModal(true);
    },
    saveSnackbar() {
      this.fetchContactRelationships(this.contactId);
    },
    showDrawerEmail() {
      const contacts = this.contactsRelated.filter(rel => rel.email);
      if (this.contact && this.contact.email) contacts.push(this.contact);
      this.setToSelected(contacts);
      this.$emit('openEmailDrawer');
    },
    goToBulkTextView() {
      const contacts = this.contactsRelated.filter(rel => rel.mobile_phone);
      if (this.contact && this.contact.mobile_phone) contacts.push(this.contact);
      this.setToSelected(contacts);
      this.$router.push('/communications/text/bulk');
    },
  },
};
</script>

<style lang="scss" scoped>
.viewAllAction {
  border-top: 1px solid var(--v-background-lighten3);
  background-color: white;
  height: 3vh;
}

.panelName {
  color: var(--v-primary-base);
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.51px;
  line-height: 19px;
}
.main-container {
  border-top: 1px solid var(--v-background-lighten3);
  border-bottom: 1px solid var(--v-background-lighten3);
}

.header-container {
  display: flex;
  flex-direction: column;
}

.card-title {
  color: #f7883e;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.51px;
  line-height: 19px;
  margin-left: 12px;
}

.card-action {
  color: #f7883e;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.44px;
  line-height: 16px;
  padding: 0px;
  margin: 0px;
  min-width: 60px;
  background: transparent !important;
  text-transform: none;
}
</style>
